import { Component, OnInit } from '@angular/core';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { Location } from '@angular/common';
import { ProjectPrepInventoryComponent } from '../project-prep-inventory/project-prep-inventory.component';
import { ProjectPrepOrdersComponent } from '../project-prep-orders/project-prep-orders.component';
import { ProjectPrepPendingComponent } from '../project-prep-pending/project-prep-pending.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-project-prep-overview',
    templateUrl: './project-prep-overview.component.html',
    styleUrls: ['./project-prep-overview.component.css'],
    imports: [NgbTooltip, FaIconComponent, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, ProjectPrepPendingComponent, ProjectPrepOrdersComponent, ProjectPrepInventoryComponent, NgbNavOutlet]
})
export class ProjectPrepOverviewComponent implements OnInit {
  
  // Font Awesome Properties
  faAngleLeft = faAngleLeft;

  constructor(public location: Location) { }

  ngOnInit(): void {

  }
}
